import { render, staticRenderFns } from "./honors.vue?vue&type=template&id=d53493fc&scoped=true&"
import script from "./honors.vue?vue&type=script&lang=js&"
export * from "./honors.vue?vue&type=script&lang=js&"
import style0 from "./honors.vue?vue&type=style&index=0&id=d53493fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53493fc",
  null
  
)

export default component.exports